import { useRef, useState, useEffect } from "react";
import { connect } from "react-redux";
import "./notificationModal.css";
function Modal(props: any) {
  const ref: any = useRef();
  const [isModalOpen, setIsModalOpen] = useState(props.show);

  // console.log(props);
  useEffect(() => {
    setIsModalOpen(props.show);
  }, [props.show]);

  useEffect(() => {
    const checkIfClickedOutside = (e: any) => {
      // If the menu is open and the clicked target is not within the menu,
      // then close the menu
      if (isModalOpen && ref.current && !ref.current.contains(e.target)) {
        setIsModalOpen(false);
      }
    };
    document.addEventListener("mousedown", checkIfClickedOutside);
    return () => {
      // Cleanup the event listener
      document.removeEventListener("mousedown", checkIfClickedOutside);
    };
  }, [isModalOpen]);

  return (
    <div>
      {isModalOpen ? (
        <div className={"notification-modal-modalU"}>
          <section className="notification-modal-modalU-main" ref={ref}>
            {props.totalCash ? (
              <h3 className={"notification-modal-custom-h"}>
                {props.language?.data?.modal?.totalCash} {props.totalCash}
                &#8378;
              </h3>
            ) : (
              ""
            )}
            <h3 className={"notification-modal-custom-h"}>{props.question}</h3>
            <div className={"notification-modal-modalU-buttons"}>
              <button
                className={
                  "notification-modal-custom-btn notification-modal-custom-btn-green"
                }
                type="button"
                onClick={props.onTrue}
              >
                {props.buttonText}
              </button>
            </div>
          </section>
        </div>
      ) : (
        ""
      )}
    </div>
  );
}

function mapStateToProps(state: any) {
  // console.log(state);
  const { isLoggedIn } = state.authReducer ?? {};
  const { message } = state.messageReducer ?? {};
  const { user } = state.user ?? {};
  const { ...language } = state.languageReducer ?? {};
  return {
    isLoggedIn,
    message,
    user,
    language,
  };
}

export default connect(mapStateToProps)(Modal);
